import React, { ReactNode, useEffect, useRef } from "react";
import Form from "./Form.jsx";
import useFormStore from "../../stores/FormStore.jsx";
import ButtonIcon from "./ButtonIcon";


const FormPOPUP = ({title, formInfo, formResponse}) => {

const containerScroll = useRef()
    const {
        openPopUp, setOpenPopUp
    } = useFormStore();

useEffect(() => {

  if ((openPopUp && window.innerWidth < 768) || (openPopUp && containerScroll.current.offsetHeight - 2 > window.innerHeight)) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = "";
  };
}, [openPopUp]);

  return (
    <>
    <div className={`${openPopUp ? 'opacity-40' : 'opacity-0'} tracking-opacity duration-300 bg-dark-blue fixed  z-[69] pointer-events-none inset-0`}></div>
    <div  className={`${openPopUp ? 'left-0' : 'left-[100%]'}  fixed transition-[left] duration-300 overflow-y-auto items-start flex justify-end top-0 w-full h-svh z-[70]`}
    >

      <div className="inset-0 absolute cursor-pointer" onClick={()=> {setOpenPopUp(false)}}></div>
      
      <div ref={containerScroll} className="lg:w-1/2  pt-[6rem] pb-[4rem] md:py-[6rem]  relative container-padding  justify-center z-10 flex flex-col items-center min-h-full bg-beige">
          <ButtonIcon ariaLabel="Закрыть форму" onClick={()=> {setOpenPopUp(false)}} className=" absolute cursor-pointer right-[2.6rem] md:right-[3rem] md:top-[2.8rem] top-[2.1rem] ">
          <svg  className="h-[1.8rem]" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 7L1 1M7 7L1 13M7 7L13 1M7 7L13 13" stroke="CurrentColor"/>
          </svg>

      </ButtonIcon>
        <p className="text-center heading-3 [&>.selected]:italic [&>.selected]:text-dusty-blue-light" dangerouslySetInnerHTML={{__html: title}}/>
        <Form formInfo={formInfo} formResponse={formResponse} isPopUp={true} idChanger="1"/>
      </div>
      
    </div>
    </>
  );
};

export default FormPOPUP;